import React, { useState, useEffect } from 'react';
import {
  Row,
  Col,
  Input,
  Form,
  Switch,
  Table,
  Select,
  Popconfirm,
  Button,
  Modal,
  Collapse,
  Badge,
  Popover,
} from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { MdArrowDropDown } from 'react-icons/md';
import { PageHeader } from '../components/page-headers/page-headers';
import axios from '../backendService';
import { GlobalUtilityStyle, PaginationStyle } from '../container/styled';
import { BiSolidVideoPlus } from 'react-icons/bi';
import AddVideoModal from '../components/video-modals/AddVideoModal';
import ExistingVideosModal from '../components/video-modals/ExistingVideosModal';
import Cookies from 'js-cookie';
import ScheduleVideoModal from '../components/video-modals/ScheduleVideoModal';

const { confirm } = Modal;
const { Option } = Select;
const { Panel } = Collapse;

function Video() {
  const [isVisible, setIsVisible] = useState(false);
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [data, setData] = useState([]);
  const [isActive, setIsActive] = useState();
  const [errorMessage, setErrorMessage] = useState('');
  const [subErr, setSubErr] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [editingDept, setEditingDept] = useState({});

  const [topicId, setTopicId] = useState('');

  // To show available video
  const [videoUrl, setVideoUrl] = useState('');
  const [isOpen, setIsOpen] = useState(false);

  const videoPlayerClose = () => {
    setVideoUrl('');
    setIsOpen(false);
  };

  const videoPlayerOpen = (videoURL) => {
    setVideoUrl(videoURL);
    setIsOpen(true);
  };

  const fetchData = async () => {
    try {
      const userId = Cookies.get('userId');
      const response = await axios.get(`/users/${userId}`);
      // console.log(response.data);
      const userData = await response.data.data.data.result;
      const allData = await response.data.data.data;
      console.log(allData);
      setData(userData);
      console.log(data)
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  //getting the data from backend
  useEffect(() => {
    fetchData();
  }, []);

  const showModal = (topicId) => {
    setTopicId(topicId);
    setIsActive('true');
    setIsVisible((state) => !state);
  };

  const handleScheduleModal = () => {
    setShowScheduleModal(true)
  }

  const handleCancel = () => {
    setEditingDept({});
    setIsVisible(false);
    setShowScheduleModal(false)
  };

  // Handle search query input change
  const onSearchQueryChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // Filter the data based on the search query
  const filteredData = data.filter((item) =>
    // item.name.toLowerCase().includes(searchQuery.toLowerCase())
    item.subjectName.toLowerCase().startsWith(searchQuery.toLowerCase()),
  );

  return (
    <main className="min-h-[715px] lg:min-h-[580px] px-8 pt-4 xl:px-[15px] bg-transparent">
      <Row gutter={30}>
        <Col xs={24}>
          <>
            <div className="bg-white dark:bg-white10 m-0 text-theme-gray dark:text-white60 text-[15px] rounded-10 relative p-[25px]">
              <div className="text-dark dark:text-white87 font-medium text-[17px] flex items-center justify-between gap-[15px] sm:justify-left mb-5">
                <div className="flex items-center justify-between gap-[15px]">
                  <h1 className="mb-0 inline-block text-ellipsis text-[18px] font-semibold sm:text-center">Subject</h1>
                  <Input
                    className="w-[150px]"
                    value={searchQuery}
                    onChange={onSearchQueryChange}
                    placeholder="Search by name..."
                  />
                </div>
                <Button
                  onClick={handleScheduleModal}
                  className="h-[50px] px-6 text-xs font-medium bg-primary-transparent text-primary border-none"
                  type="primary"
                  size="large"
                >
                  + Schedule video lecture
                </Button>
              </div>
              {/*Display subject list */}
              <div className="mt-0.5">
                <>
                  <GlobalUtilityStyle>
                    <PaginationStyle>
                      <Collapse accordion>
                        {filteredData.map((subject, index) => (
                          <Panel
                            header={
                              <div className="flex items-center justify-between">
                                <p className="mt-1 font-bold">{subject.subjectName}</p>
                                <div className="flex items-center justify-between">
                                  {/* <Badge count={'IIT-JEE'} showZero color="#faad14" className="" /> */}
                                  <MdArrowDropDown />
                                </div>
                              </div>
                            }
                            key={index}
                          >
                            <Collapse>
                              {subject.chapters.map((chapter, index) => (
                                <Panel
                                  header={
                                    <div className="flex items-center justify-between">
                                      <p className="mt-1 font-bold">{`Chapter-${chapter.chapterNo} : ${chapter.chapterName}`}</p>
                                      <MdArrowDropDown />
                                    </div>
                                  }
                                  key={index}
                                >
                                  {chapter.topics.map((topic, index) => (
                                    <div key={index} className="flex items-center justify-between w-full">
                                      <p className="mt-1 font-bold">{`Topic-${topic.topicNo} : ${topic.topicName}`}</p>
                                      <div className="flex items-center justify-between" style={{ gap: '20px' }}>
                                        <Popover
                                          placement="top"
                                          content="Add Video"
                                          action="hover"
                                          onClick={() =>
                                            showModal(
                                              // topic.topicVideo && topic.topicVideo.subject
                                              //   ? topic.topicVideo.subject._id
                                              //   : '',
                                              // topic.topicVideo && topic.topicVideo.subject
                                              //   ? topic.topicVideo.subject.subjectName
                                              //   : '',
                                              // topic.topicVideo && topic.topicVideo.chapter
                                              //   ? topic.topicVideo.chapter._id
                                              //   : '',
                                              // topic.topicVideo && topic.topicVideo.chapter
                                              //   ? topic.topicVideo.chapter.chapterName
                                              //   : '',
                                              topic._id,
                                            )
                                          }
                                        >
                                          <BiSolidVideoPlus className="w-6 h-6" style={{ color: 'green' }} />
                                        </Popover>
                                        {topic.topicVideo.videoURL && topic.topicVideo.videoURL.length !== 0 ? (
                                          <Button
                                            type="dashed"
                                            size="small"
                                            className="text-xs min-w-[100px]"
                                            onClick={() => videoPlayerOpen(topic.topicVideo.videoURL)}
                                          >
                                            Watch Video
                                          </Button>
                                        ) : (
                                          <Button type="dashed" size="small" className="text-xs min-w-[100px]" disabled>
                                            No video aded
                                          </Button>
                                        )}
                                      </div>
                                    </div>
                                  ))}
                                </Panel>
                              ))}
                            </Collapse>
                          </Panel>
                        ))}
                      </Collapse>
                    </PaginationStyle>
                  </GlobalUtilityStyle>
                </>
              </div>
            </div>
          </>
        </Col>
      </Row>
      <Modal
        title="Video Title"
        open={isOpen}
        onCancel={videoPlayerClose}
        width={1000}
        // height={500}
        className="flex items-center justify-center"
        style={{ top: 20 }}
      >
        <video src={videoUrl} width={500} height={500} controls autoPlay />
      </Modal>
      <AddVideoModal isVisible={isVisible} handleCancel={handleCancel} topicId={topicId} />
      <ScheduleVideoModal isVisible={showScheduleModal} handleCancel={handleCancel} topicId={topicId} />
    </main>
  );
}

export default Video;
